// extracted by mini-css-extract-plugin
export default {"dot":"style_dot__KQ-v6","notificationIconContainer":"style_notificationIconContainer__JCce4","notificationIcon":"style_notificationIcon__NbibC"};